import { Button } from "@heroui/button";
import { Link } from "@tanstack/react-router";

const NotFoundPage = () => {
  return (
    <section className="relative flex h-screen w-screen flex-col items-center justify-center gap-1">
      <img
        alt="bg-visual"
        src="/images/login_bg.webp"
        className="absolute inset-0 z-0 h-full w-full"
      />
      <div className="z-20 flex flex-col items-center gap-3">
        <h1 className="text-3xl">Got lost?</h1>
        <h3 className="text-base font-light">There is nothing here</h3>
        <Button
          as={Link}
          to="/atoms"
          className="mt-3 rounded-xl bg-green/10 text-lg text-green data-[hover=true]:bg-green/20"
          variant="solid"
          size="lg"
        >
          Go atoms
        </Button>
      </div>
    </section>
  );
};

export default NotFoundPage;
